(function () {
  var $ = function (id) { return document.getElementById(id); };
  var lb = $("lb");
  if (!lb) return;
  function closeLb() { lb.hidden = true; $("lbi").removeAttribute("src"); }
  document.addEventListener("click", function (e) {
    var z = e.target.closest("[data-zoom]");
    if (z) {
      var im = z.querySelector("img");
      $("lbi").src = z.getAttribute("data-full") || im.src;
      $("lbi").alt = im.alt;
      lb.hidden = false;
      $("lbx").focus();
      return;
    }
    if (!lb.hidden && e.target.closest("#lb")) { closeLb(); return; }
    var t = e.target.closest("[data-thumb]");
    if (t) {
      var main = $("pdp-img");
      if (main) { main.src = t.getAttribute("data-thumb"); main.alt = t.getAttribute("data-alt") || ""; }
      var pz = $("pdp-zoom");
      if (pz) pz.setAttribute("data-full", t.getAttribute("data-full") || t.getAttribute("data-thumb"));
      document.querySelectorAll("[data-thumb]").forEach(function (b) { b.setAttribute("aria-pressed", b === t ? "true" : "false"); });
    }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !lb.hidden) closeLb(); });
})();
